var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.42 19.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22a081;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.68.09A5,5,0,0,0,19.85,5a5.85,5.85,0,0,0,.72.07c.09,0,.14,0,.14.13,0,1,0,2,0,3a.25.25,0,0,1,0,.07,7.78,7.78,0,0,1-2.62-.43,8.74,8.74,0,0,1-2.37-1.26v.24c0,2.25,0,4.51,0,6.76a6,6,0,0,1-1,3.44A6,6,0,0,1,9.12,19.9a6.11,6.11,0,0,1-1.41-12,6.37,6.37,0,0,1,2.49-.23l.22,0V11l-.16,0a2.93,2.93,0,1,0,2.12,3.41,3.8,3.8,0,0,0,.06-.75q0-6.61,0-13.24a2.83,2.83,0,0,1,0-.29Z",
    transform: "translate(-3.29 -0.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokicon);
export default __webpack_public_path__ + "static/media/tiktokicon.ca5e162c530181665a61d152ffbf2d13.svg";
export { ForwardRef as ReactComponent };